import { api } from 'repositories/api';
import { PostcodeModel, DeliveryTypes } from 'models';
import { BasketErrorModel, DEFAULT_ERROR_TEXT } from 'models/Errors';
import { basketStorage } from 'storages';
import { DeliveryModeCodes, BasketDetailsModel } from 'models/Basket';

export class DeliveryHelper {
    public async calculateDeliveryCost(prevPostcode: PostcodeModel | null, updatedPostcode: PostcodeModel | null, username: string | null, basketId: string): Promise<void> {
        if (updatedPostcode === null) {
            throw new BasketErrorModel(DEFAULT_ERROR_TEXT, 'Calculate delivery cost error: postcode is null', 'deliveryHelper:calculateDeliveryCost');
        }

        await api.hybris.calculateDeliveryCost(updatedPostcode, username, basketId);

        if (prevPostcode?.code !== updatedPostcode?.code) {
            basketStorage.removeDeliveryType();
        }
    }

    public shouldWaitForChoosingDeliveryType(basket: BasketDetailsModel | null) {
        // if we have NonMainland postcode (for example: IM1 1AA) and price for this postcode has not approved (by separated api call)
        // then backend returns delivery type nonMainland, but deliveryCost === 0,
        // so, we should show approve delivery button.
        // After delivery price approved, backend returns the same delivery type, but deliveryCost > 0.

        // exception: if we have only Dwell items in the basket - then deliveryCost still === 0
        // therefore we have to save flag about selected delivery type in localStorage -
        // to distinguish between approved and not approved delivery (for nonMainland) for Dwells only basket

        return Boolean(
            basket?.deliveryMode?.code === DeliveryModeCodes.NonMainland
            && basket.deliveryCost?.value === 0
            && basketStorage.getDeliveryType() !== DeliveryTypes.NonMainlandDelivery
        );
    }
}

export const deliveryHelper = new DeliveryHelper();